// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "8b52c891e68e4e96","396": "71faf33437fc2b17","460": "5698995e780922e7","917": "8f0ee9ad7b86407d","985": "e297439b44209a85",}[chunkId] + ".chunk.js"
}